// Module
var code = "<suppliers></suppliers>\n";
// Exports
module.exports = code;